import React, { useEffect, useState } from "react";
import { Box, IconButton, TextField, Button, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getRecordingPlaybackUrl } from "../../../../store/RecordedCalls/recordedCallsThunks";

const PlayPanelContentWithComments = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const [audioUrl, setAudioUrl] = useState(null);
  const [comments, setComments] = useState([]);
  const [newTime, setNewTime] = useState("");
  const [newComment, setNewComment] = useState("");

  const { loadingPlayback, playbackError } = useSelector(
    (state) => state.recordedCalls
  );

  useEffect(() => {
    let currentObjectUrl = null;

    const fetchAudio = async () => {
      try {
        const action = await dispatch(
          getRecordingPlaybackUrl({ recordingId: row.id })
        );

        if (action.meta.requestStatus === "fulfilled") {
          const blob = new Blob([action.payload], { type: "audio/mpeg" });
          currentObjectUrl = URL.createObjectURL(blob);
          setAudioUrl(currentObjectUrl);
        } else {
          console.error("Playback error:", action.payload);
        }
      } catch (error) {
        console.error("Error dispatching playback thunk", error);
      }
    };

    fetchAudio();

    return () => {
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
      }
    };
  }, [dispatch, row.id]);

  const handleSubmitComment = () => {
    if (!newTime || !newComment) return;
    setComments((prev) => [
      ...prev,
      { time: newTime, text: newComment, id: Date.now() },
    ]);
    setNewTime("");
    setNewComment("");
  };

  return (
    <Box sx={{ p: 2, position: "relative" }}>
      <IconButton
        onClick={onClose}
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>

      {loadingPlayback && <p>Loading audio...</p>}
      {playbackError && <p style={{ color: "red" }}>{playbackError}</p>}
      {audioUrl && (
        <AudioPlayer
          src={audioUrl}
          showJumpControls={false}
          autoPlay={false}
          layout="horizontal-reverse"
        />
      )}

      {/* Comments section */}
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {/* Left side: Timeline */}
          <Grid item xs={6}>
            {comments.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  minHeight: 150,
                }}
              >
                No comments
              </Box>
            ) : (
              <Timeline position="alternate">
                {comments.map((comment) => (
                  <TimelineItem key={comment.id}>
                    <TimelineOppositeContent color="text.secondary">
                      {comment.time}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>{comment.text}</TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            )}
          </Grid>

          {/* Right side: Comment form */}
          <Grid item xs={6}>
            <TextField
              label="Time"
              value={newTime}
              onChange={(e) => setNewTime(e.target.value)}
              fullWidth
              sx={{ mb: 1 }}
            />
            <TextField
              label="Comment"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              fullWidth
              multiline
              rows={3}
              sx={{ mb: 1 }}
            />
            <Button variant="contained" onClick={handleSubmitComment} fullWidth>
              Add Comment
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PlayPanelContentWithComments;
